import { PropsWithChildren } from "react";
import { InfoIcon } from "lucide-react";

import { PropsWithClassNameI } from "shared/lib/interfaces/ui";
import { Button } from "shared/ui/shadcn/button";
import { DocsDisplayTypeI } from "shared/lib/interfaces/docs";
import { DOCS_DISPLAY_TYPE } from "shared/lib/constants/docs";

import { openDocsSidebar, setDocsSpaceId, setDocsPath } from "@/lib/store/docs";
import { DocsTooltip } from "@/components/shared/docs/docs-tooltip";

interface DocsTriggerButtonPropsI
  extends PropsWithClassNameI, PropsWithChildren {
  spaceId: string;
  path: string;
  type?: DocsDisplayTypeI;
}

export const DocsTriggerButton = ({
  className,
  children,
  spaceId,
  path,
  type = DOCS_DISPLAY_TYPE.SIDEBAR,
}: DocsTriggerButtonPropsI) => {
  const handleOnOpenSidebar = () => {
    // set the spaceId and path in the store so it could be accessed
    // inside the sidebar component to load the appropriate data when the sidebar is opened
    setDocsSpaceId(spaceId);
    setDocsPath(path);
    openDocsSidebar();
  };

  return (
    <>
      {type === DOCS_DISPLAY_TYPE.SIDEBAR && (
        <Button
          variant="outline"
          size="sm"
          className={className}
          onClick={handleOnOpenSidebar}
        >
          {children || <InfoIcon className="size-4" />}
        </Button>
      )}

      {type === DOCS_DISPLAY_TYPE.TOOLTIP && (
        <DocsTooltip spaceId={spaceId} path={path}>
          {children || <InfoIcon className="size-4" />}
        </DocsTooltip>
      )}
    </>
  );
};
